<template>
  <div class="main">
    <div class="title-bar">
      <h1>Login</h1>
    </div>
    <div class="container py-3">
      <FormWrapper id="login-form" method="POST" :action="route('login')">
        <transition name="fade">
          <Alert v-if="hasAlert" :alert="alert" class="text-center" />
        </transition>
        <div class="row mt-4">
            <div v-if="webView" class="col-12 text-center">
                <p class="mb-2">
                    <strong>Have an HVACpartners account?</strong>
                    <br />Use the button below to log in.
                </p>
                <a class="btn btn-primary" :href="hvacpLoginUrl">HVACp Login</a>
            </div>

            <div v-if="webView" class="col-12 mt-5 mb-3 text-center mb-md-0">
                <p class="mb-2">
                    <strong>Don't utilize HVACpartners?</strong>
                    <br />Use the form below to login.
                </p>
            </div>

          <div v-if="!webView" class="col-12 text-center col-md-6">
            <p class="mb-2">
              <strong>Have an HVACpartners account?</strong>
              <br />Use the button below to log in.
            </p>
            <a class="btn btn-success" :href="hvacpLoginUrl">HVACp Login</a>
          </div>
          <div v-if="!webView" class="col-12 mb-3 text-center col-md-6 mb-md-0">
            <p class="mb-2">
              <strong>Need an account?</strong>
              <br />Use the button below to register.
            </p>
            <a class="btn btn-success" :href="route('register')">Create Account</a>        
          </div>

          <div v-if="!webView" class="col-12 mt-4">
              <hr class="thick" />
          </div>

          <div class="col-12 mb-3 mt-4">
            <p class="mb-3 text-center">
                <strong>Already have an MLCtraining.com account? Login here.</strong>
            </p>
            <div class="w-75 m-auto">
                <Field
                    type="text"
                    label="Email"
                    name="username"
                    value=""
                    validate="required"
                    validate-as="email"
                    class="mb-3"
                />
                <Field
                    type="password"
                    label="Password"
                    name="password"
                    value=""
                    validate="required"
                    @enter="login"
                />
            </div>
          </div>
          <div class="col-12 text-center">
            <button type="submit" class="btn btn-secondary mr-3">Login</button>
            <button
              v-if="!webView"
              type="button"
              class="btn btn-danger"
              @click.prevent="goToRoute('password.request')"
            >Forgot Password</button>
          </div>
        </div>
      </FormWrapper>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    hvacpLoginUrl: { type: String, required: true },
    webView: { type: Boolean, default: false }
  },
  methods: {
    login() {
      document.getElementById("login-form").submit();
    }
  }
};
</script>

<style lang="scss" scoped>
 p {
   font-size: 0.875rem;
 }
 .container {
   max-width: 576px;
 }
</style>